// A row's actions behind "⋯" (APS-412, admin-d.md "Tables"): for a row with two or more actions,
// or one destructive and rare (a kill switch, erasing a person), so a table never ends in a
// column of red buttons. Console D's popover (.pop, @apsio/ui usePopover) with menu items
// (.pal-i), a destructive one in the danger tone. An item only says what was chosen: the route
// opens its FormWindow, or a ConfirmDialog for what cannot be taken back.
import { usePopover } from '@apsio/ui'
import { useId } from 'react'

export interface RowMenuItem {
  label: string
  onSelect: () => void
  /** Destructive: in the danger tone, last, after a rule. */
  danger?: boolean | undefined
}

export function RowMenu({ label, items }: { label: string; items: RowMenuItem[] }) {
  // The menu lives inside a row: a new page unmounts the table, and the menu with it.
  const pop = usePopover('', 'below')
  const id = useId()
  const safe = items.filter((i) => !i.danger)
  const danger = items.filter((i) => i.danger)
  const choose = (item: RowMenuItem) => {
    pop.close()
    item.onSelect()
  }
  return (
    <>
      <button
        ref={pop.anchor}
        type="button"
        className="btn ghost sm row-menu"
        aria-label={label}
        aria-expanded={pop.open}
        aria-controls={pop.open ? id : undefined}
        aria-haspopup="true"
        onClick={pop.toggle}
      >
        <span aria-hidden="true">⋯</span>
      </button>
      {pop.open ? (
        <section ref={pop.pop} id={id} className="pop row-pop" style={pop.style} aria-label={label}>
          {safe.map((item) => (
            <button key={item.label} type="button" className="pal-i" onClick={() => choose(item)}>
              {item.label}
            </button>
          ))}
          {safe.length > 0 && danger.length > 0 ? <hr /> : null}
          {danger.map((item) => (
            <button
              key={item.label}
              type="button"
              className="pal-i danger"
              onClick={() => choose(item)}
            >
              {item.label}
            </button>
          ))}
        </section>
      ) : null}
    </>
  )
}
